import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function ProduceButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.produce")}</ActionButtonLayout>;

}

export default ProduceButtonLayout;

